export const SEND_WEEKLY_EMAILS = 'send-weekly-emails/SEND_WEEKLY_EMAILS';
export const SEND_WEEKLY_EMAILS_SUCCESS = 'send-weekly-emails/SEND_WEEKLY_EMAILS_SUCCESS';
export const SEND_WEEKLY_EMAILS_FAILED = 'send-weekly-emails/SEND_WEEKLY_EMAILS_FAILED';
export const CLEAR_USER_STATE = 'send-weekly-emails/CLEAR_USER_STATE';
export const SAVE_EMAIL_TEXT = 'send-weekly-emails/SAVE_EMAIL_TEXT';
export const SAVE_EMAIL_TEXT_SUCCESS = 'send-weekly-emails/SAVE_EMAIL_TEXT_SUCCESS';
export const UPDATE_EMAIL_TEXT = 'send-weekly-emails/UPDATE_EMAIL_TEXT';
export const UPDATE_EMAIL_TEXT_SUCCESS = 'send-weekly-emails/UPDATE_EMAIL_TEXT_SUCCESS';
export const GET_WEEKLY_EMAIL_TEXT = 'send-weekly-emails/GET_WEEKLY_EMAIL_TEXT';
export const GET_WEEKLY_EMAIL_TEXT_SUCCESS = 'send-weekly-emails/GET_WEEKLY_EMAIL_TEXT_SUCCESS';
